<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
    <div class="row mb-2">
        <div class="col pl-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
    <div class="row mt-2 mb-3">
        <h4 class="mb-2 py-1 font-header-1">Timesheet </h4>

    </div>
    <!-- Filters -->
    <!-- Filters -->
    <div class="row mb-2">
        <div class="col ">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <!-- start Date & end date -->
                    <div class="row">
                        <div class="col-lg-4">
                            <div class="row">
                                <div class="col-lg-4">
                                    <span>Start date</span>
                                </div>

                                <div class="col-lg-7 col-11  ">
                                    <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                        [selDate]="FromDateFilter"
                                        (inputFieldChanged)="DateFormat($event,'inputchanged','FilterFromDate')"
                                        (dateChanged)="DateFormat($event,'datechanged','FilterFromDate')">
                                    </my-date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="row">
                                <div class="col-lg-4">
                                    <span>End date</span>
                                </div>
                                <div class="col-lg-7 col-11 ">
                                    <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                        [selDate]="EndDateFilter"
                                        (inputFieldChanged)="DateFormat($event,'inputchanged','FilterToDate')"
                                        (dateChanged)="DateFormat($event,'datechanged','FilterToDate')">
                                    </my-date-picker>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="row">
                                <div class="col-lg-3 col-11">
                                    <span>service</span>
                                </div>
                                <div class="col-lg-8  col-11">
                                    <ng-select [(ngModel)]="TimesheetFilterBo.service" [searchable]="true"
                                        [clearable]="true" [items]="serviceList" bindLabel="Value" bindValue="Key">
                                    </ng-select>
                                </div>
                            </div>
                        </div>


                    </div>
                    <!-- CLient & employee  -->
                    <div class="row mt-4">
                        <div class="col-lg-4">
                            <div class="row">
                                <div class="col-lg-4">
                                    <span>Employee</span>
                                </div>
                                <div class="col-lg-7 col-11 ">
                                    <ng-select [searchable]="true" [(ngModel)]="EmployeeListFilter" [clearable]="true"
                                        bindLabel="Value" bindValue="Key" [items]="AllEmployeeDropDownList">
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 me-4">
                            <div class="row">
                                <div class="col-lg-4">
                                    <span>Client</span>
                                </div>
                                <div class="col-lg-7 col-11 ">
                                    <ng-select [searchable]="true" [(ngModel)]="ClientListFilter" [clearable]="true"
                                        bindLabel="Value" bindValue="Key" [items]="AllClientDropDownList">
                                    </ng-select>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-2 text-end mt-2">
                            <div>
                                <button type="button" class="btn btn-sm me-3" (click)="exportCsv()">
                                    <i class="fa fa-file-excel-o "></i>Export</button>
                                <button type="button" class="btn btn-sm me-2" (click)="ApplyFilter()">Apply
                                </button>
                                <button type="button" class="btn btn-sm" (click)="RefreshFilter()"
                                    style="margin-left: 11px;">Refresh
                                </button>
                            </div>
                        </div>

                    </div>
                    <div class="row mb-2 mt-4">

                        <div class="col-lg-8">
                            <div>
                                <button type="button" class="btn btn-sm blue-btn" (click)="UpdateRateTimesheet()"
                                    [disabled]="IsButtonDisable || (ClientListFilter == null && ClientListFilter == undefined)||(EmployeeListFilter == null && EmployeeListFilter == undefined) "
                                    *ngIf="fp.timesheetmultipleupdate">
                                    Re-Calculate Rate</button>&nbsp;&nbsp;
                                <button type="button" class="btn btn-sm blue-btn" (click)="TimesheetEmitpage()"
                                    *ngIf="fp.timesheetcreate">Add
                                    Timesheet Entry</button>&nbsp;&nbsp;
                                <button type="button" class="btn btn-sm me-3" data-bs-target="#BulkUpdate"
                                    data-bs-toggle="modal" (click)="getBulkUpdateActiveAuths()"
                                    *ngIf="global.loginusername=='SUPERADMIN'"
                                    [disabled]="ClientListFilter == '' || ClientListFilter == null || ClientListFilter == undefined || ClientListFilter == '00000000-0000-0000-0000-000000000000'
                                    || EmployeeListFilter == '' || EmployeeListFilter == null || EmployeeListFilter == undefined || EmployeeListFilter == '00000000-0000-0000-0000-000000000000'
                                    || TimesheetFilterBo.service == '' || TimesheetFilterBo.service == null || TimesheetFilterBo.service == undefined || TimesheetFilterBo.service == '00000000-0000-0000-0000-000000000000'
                                    || FromDateFilter == ''|| FromDateFilter == null || FromDateFilter == undefined || EndDateFilter == '' || EndDateFilter == null || EndDateFilter ==undefined">
                                    <i class="fa fa-file-excel-o "></i>Timesheet Bulk Update To T2025</button>
                            </div>
                        </div>


                    </div>

                </div>
            </div>
        </div>
    </div>

    <!-- ejs-grid -->
    <div class="row mb-2">
        <div class="col ">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <!-- -->
                    <ejs-grid #gridTimesheet [dataSource]='GridList | async' [allowPaging]='true'
                        [pageSettings]='initialPage' [filterSettings]='filterSettings' [allowFiltering]='true'
                        [allowResizing]='true' (dataStateChange)='dataChangeTimesheet($event)'
                        [showColumnChooser]='true' (actionBegin)="onActionTimesheet($event)" [allowSorting]='true'>
                        <e-columns>
                            <e-column minWidth=100 headerText="Actions" [showInColumnChooser]='false'>
                                <ng-template #template let-data>
                                    <button class="btn btn-sm btn-edit-table" (click)="getDetails(data)"
                                        [disabled]="(data.eTimesheet==true || data.eTimesheet == 'YES' || data.hasClaim)"
                                        data-bs-target="#updateTimesheetmodal" data-bs-toggle="modal"
                                        *ngIf="fp.timesheetupdate"><i class="fa fa-edit"></i></button>&nbsp;
                                    <button class="btn btn-sm btn-delete-table" data-bs-target="#DeleteTimesheeModal"
                                        [disabled]="(data.eTimesheet==true || data.eTimesheet == 'YES' || data.hasClaim)"
                                        data-bs-toggle="modal" (click)="getDeleteDetails(data)"
                                        *ngIf="fp.timesheetdelete"><i class="fa fa-trash"></i></button>
                                </ng-template>
                            </e-column>
                            <!-- Client Name -->
                            <e-column minWidth=100 field="client" headerText="Client Name" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Employee Name -->
                            <e-column minWidth=100 field="employee" headerText="Employee Name" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Service -->
                            <e-column minWidth=100 field="serviceName" headerText="Service" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Payor Name -->
                            <e-column minWidth=100 field="payer" headerText="Payor" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Rate -->
                            <e-column minWidth=100 field="payRate" headerText="Rate"
                                type="number">
                            </e-column>
                            <e-column minWidth=100 field="hours" [allowResizing]='false'
                                headerText="Total Hours" type="number">
                            </e-column>
                            <!-- Total Amount -->
                            <e-column minWidth='150' field="totalAmount" [allowResizing]='false'
                                headerText="Total Amount" type="number">
                                <!-- <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template> -->
                            </e-column>
                            <e-column minWidth='150' field="totaltaxamount" headerText="Total Tax Amount" type="number">
                                <!-- <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template> -->
                            </e-column>
                             <e-column minWidth='150' field="overTimeHours" headerText="Over Time Hours" type="number">
                                <!-- <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template> -->
                            </e-column> 
                            <e-column minWidth=100 field="timesheetDate" [allowFiltering]='false'
                                [format]='formatOptions' headerText="Timesheet Date" type="date">
                            </e-column>
                            <e-column minWidth=100 field="hasClaim" headerText="Exported" [allowFiltering]='false'
                                [allowSorting]='false'>
                            </e-column>

                            <e-column minWidth=100 field="timesheetNotes" headerText="Notes" type='string' [allowSorting]='false'>
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- ETimesheet -->
                            <e-column minWidth=100 field="eTimesheet" headerText="E-Timesheet" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-dropdownlist id='dropdata3' placeholder='Select a E-Timesheet'
                                        [dataSource]='dropdatas' [popupHeight]='height'></ejs-dropdownlist>
                                </ng-template>
                            </e-column>



                            <e-column width="50" [showInColumnChooser]='false'>
                                <ng-template #headerTemplate let-data>
                                    <div>
                                        <span id='show' (click)='showTimesheetColumns()'><i class="fa fa-cog fa-lg"
                                                aria-hidden="true">
                                            </i></span>
                                    </div>
                                </ng-template>
                            </e-column>
                        </e-columns>


                    </ejs-grid>
                    <div class="row mb-2">
                        <div class="col pl-0">
                            <div widget class="card border-0 box-shadow">
                                <div class="card-body  widget-body pt-2">
                                    <div class="text-center">
                                        <label class="me-2">Total Hours:</label>{{totalhoursSummaryMinutes}}&nbsp;&nbsp;&nbsp;
                                        <label class="me-2">Total Amount:</label>{{showTotalamount}}&nbsp;&nbsp;&nbsp;
                                        <label class="me-2">Total TaxAmount:</label>{{totalTax}}&nbsp;&nbsp;&nbsp;
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- for Update Modal-->
<span id="openUpdateTimesheetModal" data-bs-target="#updateTimesheetmodal" data-bs-toggle="modal"></span>
<div class="modal fade " id="updateTimesheetmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Update Timesheet</h5>
                <button type="button" class="btn btn-sm-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <!-- Client Name -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Client
                                <sup class="super-script">*</sup></label>
                        </div>
                        <div class="col-lg-12">
                            <ng-select [searchable]="true" [(ngModel)]="updateTimesheetInfo.clientId" [clearable]="true"
                                disabled (ngModelChange)="GetMappedEmployees()" bindLabel="Value" bindValue="Key"
                                [items]="ClientDropDownList" class="w-100">
                            </ng-select>
                        </div>
                    </div>
                    <!-- Employee Name -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Employee
                                <sup class="super-script">*</sup></label>
                        </div>
                        <div class="col-lg-12">
                            <ng-select [searchable]="true" [(ngModel)]="updateTimesheetInfo.employeeId"
                                [clearable]="true" disabled bindLabel="employeeName" bindValue="employeeId"
                                [items]="EmployeeMappedList" class="w-100">
                            </ng-select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- TimeSheet Date -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">TimeSheet
                                Date<sup class="super-script">*</sup></label>
                        </div>
                        <div class="col-lg-12">
                            <my-date-picker [options]="myDatePickerOptions"
                                [selDate]="updateTimesheetInfo.timesheetDate" placeholder="mm/dd/yyyy"
                                (inputFieldChanged)="DateFormat($event,'inputchanged','TimesheetDate');getActiveAuthorization()"
                                (dateChanged)="DateFormat($event,'datechanged','TimesheetDate')">
                            </my-date-picker>
                        </div>
                    </div>
                    <!-- Service -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Service<sup class="super-script">*</sup></label>
                        </div>
                        <div class="col-lg-12">
                            <input type="text" class="form-control" [(ngModel)]="serviceField" disabled>

                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- Work Hour-->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Total
                                Hours<sup class="super-script">*</sup></label>
                        </div>
                        <div class="col-lg-12">
                            <input type="text" *ngIf="isTransportation" class="form-control"
                                [(ngModel)]="updateWorkHours" (ngModelChange)="CalculateTotalAmount()"
                                (keypress)="numberonlyTrasportation($event,'UpdateTimesheet')">
                            <input type="text" *ngIf="!isTransportation" class="form-control"
                                [(ngModel)]="updateWorkHours" (ngModelChange)="CalculateTotalAmount()"
                                (keypress)="numberonly($event,'UpdateTimesheet')">
                        </div>
                    </div>
                    <!-- Notes-->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Notes</label>
                        </div>
                        <div class="col-lg-12">
                            <input type="text" class="form-control" [(ngModel)]="updateTimesheetInfo.timesheetNotes">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- Payrate -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Payrate
                            </label>
                        </div>
                        <div class="col-lg-12">
                            <input type="text" class="form-control" [(ngModel)]="payRate" disabled>
                        </div>
                    </div>
                    <!-- Total Amount-->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Total
                                Amount</label>
                        </div>
                        <div class="col-lg-12">
                            <input type="text" class="form-control" [(ngModel)]="totalAmount" disabled>
                        </div>
                    </div>

                </div>

                <div class="row mt-3" *ngIf="ActiveAuthorizationList?.length > 0">
                    <div class="col-lg-12">
                        <ejs-grid #gridActiveAuthorization [dataSource]='ActiveAuthorizationList' [rowHeight]='40'
                            [pageSettings]='AuthorizationinitialPage' [allowPaging]='true'
                            (rowSelected)='rowSelected($event)' [allowResizing]='true'>
                            <e-columns>
                                <!-- startdate -->
                                <e-column field="startDate" headerText="Start Date" minWidth=120
                                    [format]='formatOptions' type="date">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <!-- enddate -->
                                <e-column field="endDate" headerText="End Date" minWidth=120 [format]='formatOptions'
                                    type="date">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <!-- Service -->
                                <e-column minWidth=100 field="serviceCodeName" headerText="Service">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="authNote" headerText="AuthNote">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>

                                <e-column minWidth=100 field="serviceGroup" headerText="Service Group">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>



                                <!-- BalanceAmount -->
                                <e-column field="balanceAmount" headerText="Remaining Amount" minWidth=120>
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>


                                <!-- Payor -->
                                <e-column field="payor" headerText="Payor" minWidth=120>
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <!-- Rate -->
                                <e-column minWidth=100 field="rate" headerText="Rate">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="insuranceNumber" headerText="InsuranceNumber">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>

                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="row">
                    <div class="col-lg-12">
                        <button class="btn btn-sm blue-btn" (click)="UpdateTimesheet()"
                            [disabled]="updateTimesheetInfo.clientId==null || updateTimesheetInfo.clientId==undefined || updateTimesheetInfo.clientId==''||
                        updateTimesheetInfo.employeeId==null || updateTimesheetInfo.employeeId==undefined || updateTimesheetInfo.employeeId=='' ||
                        updateWorkHours==null || updateWorkHours==undefined || updateWorkHours=='0' ||updateWorkHours==''||updateWorkHours=='00'|| 
                        updateTimesheetInfo.timesheetDate==null || updateTimesheetInfo.timesheetDate==undefined || updateTimesheetInfo.timesheetDate==''
                        || authId =='' || authId == null || authId == undefined || authId == '00000000-0000-0000-0000-000000000000' || IsButtonDisable">
                            Update & Close
                        </button>&nbsp;
                        <button class="btn btn-sm blue-btn " data-bs-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Delete Modal -->
<span data-bs-target="#DeleteTimesheeModal" data-bs-toggle="modal" id="openTimesheetdeleteModal"></span>
<div class="modal fade " id="DeleteTimesheeModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Delete Timesheet</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="CancelDelete()"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="DeleteForms">
                    <div class="row">
                        <div class="col-lg-2">
                            <label style="font-weight: 600;margin-top:6px;">Password<sup style="color:red; font-size: 1.35em;
                          top: 0em;">&nbsp;*</sup></label>
                        </div>
                        <div class="col-lg-5">
                            <input type="password" class="form-control" formControlName="Password"
                                [(ngModel)]="deletelist.admin_Password" (keyup)="passvalid($event)">
                            <div *ngIf="DeleteForms.controls['Password'].invalid && (DeleteForms.controls['Password'].dirty || DeleteForms.controls['Password'].touched) "
                                class="alert alert-danger" style="height: 43px; margin-top: 2px;">
                                <div *ngIf="DeleteForms.controls['Password'].errors.required">
                                    Password is required.
                                </div>
                            </div>
                            <div *ngIf="validationError && DeleteForms.controls['Password'].valid  "
                                class="alert alert-danger">
                                <div>
                                    Enter Valid Password
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <label class="passwordnote mt-5"><i>Note:&nbsp;Password should
                                    contain atleast 8
                                    characters/
                                    digits includes 1 special character, 1 lower and uppercase characters
                                </i></label>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm blue-btn"
                    [disabled]="!DeleteForms.valid ||validationError || IsButtonDisable"
                    (click)="DeleteTimeSheet()">Delete</button>
                <button type="button" class="btn btn-sm blue-btn" data-bs-dismiss="modal"
                    (click)="CancelDelete()">Cancel</button>
            </div>
        </div>
    </div>
</div>


<!-- .....................................ReCalculate-Rate............................................................. -->
<span id="UpdateRatetimesheet" data-bs-target="#UpdateRatetimesheet1" data-bs-toggle="modal"></span>
<div class="modal fade " id="UpdateRatetimesheet1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md " role="document">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Re-Calculate Rate</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">


                <div class="row">
                    <div class="col-lg-5">

                        <label>StartDate<sup class="super-script">*</sup>
                        </label>
                    </div>


                    <div class="col-lg-7">
                        <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                            [selDate]="startenddateBo.startDate"
                            (inputFieldChanged)="DateFormat($event,'inputchanged','StartDate')"
                            (dateChanged)="DateFormat($event,'datechanged','StartDate')">
                        </my-date-picker>
                    </div>

                </div>

                <div class="row">
                    <div class="col-lg-5 ">
                        <label>EndDate<sup class="super-script">*</sup>
                        </label>
                    </div>

                    <div class="col-lg-7">
                        <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                            [selDate]="startenddateBo.endDate"
                            (inputFieldChanged)="DateFormat($event,'inputchanged','EndDate')"
                            (dateChanged)="DateFormat($event,'datechanged','EndDate')">
                        </my-date-picker>
                    </div>

                </div>


            </div>


            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-sm" [disabled]="(startenddateBo.startDate==''||startenddateBo.startDate==undefined||
                startenddateBo.endDate==''||startenddateBo.endDate==undefined)"
                    (click)=" UpdateRateTimesheet()">Update</button>
                <button type="button" class="btn btn-sm btn-sm" data-bs-dismiss="modal">Close</button>
            </div>



        </div>



    </div>
</div>

<!--------------------------------BulkServiceCode Update-->
<span data-bs-target="#BulkUpdate" data-bs-toggle="modal" id="updateauth"></span>
<div class="modal fade " id="BulkUpdate" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">

    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <label class="font-header">Timesheets Bulk Update</label>

                <button type="button" class="btn-close" data-bs-dismiss="modal"
                    (click)="closeBulkUpdate()">&times;</button>
            </div>
            <div class="modal-body">
                <span *ngIf="UpdateAuthorizationList?.length == 0 && IsBulkUpdate">No Authorization found</span>
                <div class="row" *ngIf="UpdateAuthorizationList?.length > 0">
                    <div class="col-lg-12">

                        <ejs-grid [dataSource]='UpdateAuthorizationList' [rowHeight]='40'
                            [pageSettings]='UpdateAuthorizationinitialPage' [allowPaging]='true'
                            (queryCellInfo)='customiseCell($event)'
                            (rowSelected)='rowSelectedForBulkVisitUpdate($event)' [allowResizing]='true'>
                            <e-columns>
                                <!-- startdate -->
                                <e-column field="startDate" headerText="Start Date" minWidth=120
                                    [format]='formatOptions' type="date">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <!-- enddate -->
                                <e-column field="endDate" headerText="End Date" minWidth=120 [format]='formatOptions'
                                    type="date">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <!-- Service -->
                                <e-column minWidth=100 field="serviceCodeName" headerText="Service" minWidth=200>
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="authNote" headerText="AuthNote">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>

                                <e-column minWidth=100 field="serviceGroup" headerText="Service Group">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>



                                <!-- BalanceAmount -->
                                <e-column field="balanceAmount" headerText="Remaining Amount" minWidth=120>
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>


                                <!-- Payor -->
                                <e-column field="payor" headerText="Payor" minWidth=120>
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <!-- Rate -->
                                <e-column minWidth=100 field="rate" headerText="Rate">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="insuranceNumber" headerText="InsuranceNumber">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>

                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
            <div class="modal-footer mt-3">
                <button *ngIf="UpdateAuthorizationList?.length > 0" type="button" class="btn btn-sm" 
                    [disabled]="IsButtonDisable || bulkUpdateAuthId == '' || bulkUpdateAuthId == null || bulkUpdateAuthId == undefined || bulkUpdateAuthId == '00000000-0000-0000-0000-000000000000'"
                    (click)="updatebulktimesheets()">Update & Close</button>
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal" *ngIf="UpdateAuthorizationList?.length == 0"
                    (click)="closeBulkUpdate()">Close</button>

            </div>
        </div>
    </div>
</div>

<span id="errorpopup" data-bs-toggle="modal" data-bs-target="#errormodal"></span>
<div class="modal fade modalbackgrod" tabindex="-1" id="errormodal" data-bs-backdrop="static">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" style="color: #502189;"><b>Error Status</b></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body mt-3">
                <div *ngFor="let items of errorList">
                    <b class="text-danger">"{{items}}"</b>
                </div>
            </div>
            <div class="modal-footer mt-3">
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal">Close</button>

            </div>
        </div>
    </div>
</div>